/**
 * Règles d'affichage des avis, section 9 du dossier de synthèse.
 *
 * Elles sont isolées ici plutôt que dans un composant parce qu'elles seront
 * réutilisées par la fiche produit, la liste de recherche, la page producteur et
 * les critères d'éligibilité à la mise en avant sectorielle. Une règle recopiée
 * dans quatre écrans finit toujours par diverger dans l'un des quatre.
 */

/**
 * Nombre d'avis minimum avant d'afficher une note moyenne publique.
 *
 * Protection des nouveaux producteurs : sans ce seuil, un unique client
 * mécontent fixerait durablement la réputation d'un producteur qui démarre.
 */
export const MIN_REVIEWS_FOR_AVERAGE = 3;

export function canShowAverage(reviewCount: number): boolean {
  return reviewCount >= MIN_REVIEWS_FOR_AVERAGE;
}

const RATING = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** Formate une note à la française : « 4,8 ». */
export function formatRating(average: number): string {
  return RATING.format(average);
}
